import { Pagination, Button } from 'antd'
import { useRouter } from 'next/router'
import useTranslation from '@/hooks/useTranslation'

import styles from './Pagination.module.css'

export default function PaginationC({
  current,
  total,
  pageSize,
}) {
  const router = useRouter()
  const { t } = useTranslation()

  const itemRender = (_, type, originalElement) => {
    if (type === 'prev') {
      return <Button className='btn-pagination'>{t('Back')}</Button>
    }

    if (type === 'next') {
      return <Button className='btn-pagination'>{t('Next')}</Button>
    }

    return originalElement
  }

  return (
    <div className={`${styles.pagination} flex items-center justify-end mt-24`}>
      <Pagination
        pageSize={pageSize ? pageSize : 15}
        className='mx-8'
        defaultCurrent={1}
        total={total}
        itemRender={itemRender}
        onChange={(page) =>
          router.replace({
            query: { ...router.query, page },
          })
        }
        current={current}
      />
    </div>
  )
}
